import { Task } from "@/data/models/Task";
import { SchedulingSettings } from "@/data/models/SchedulingSettings";
import { DateTime } from "luxon";
import { TimeSlot } from "./TimeSlot";
import { TimeSlotsOfDayIterator } from "./TimeSlotsOfDayIterator";
import { DaysIterator } from "./DaysIterator";

export class TimeSlotsIterator {
  private currentDateTime: DateTime | null;

  private timeSlotsOfDayIterator: TimeSlotsOfDayIterator;
  private daysIterator: DaysIterator;

  constructor(
    startFrom: Date,
    task: Task,
    schedulingSettings: SchedulingSettings,
    skipWeekends: boolean,
    forceStartDate?: boolean
  ) {
    const startDate =
      startFrom.getTime() > task.earliestStartDate.getTime()
        ? startFrom
        : task.earliestStartDate;

    this.timeSlotsOfDayIterator = new TimeSlotsOfDayIterator(
      task,
      schedulingSettings
    );

    this.daysIterator = new DaysIterator(
      startDate,
      task,
      skipWeekends,
      forceStartDate
    );

    this.currentDateTime = this.daysIterator.getNextDateTime();

    if (this.currentDateTime) {
      this.timeSlotsOfDayIterator.setCurrentDateTime(
        this.currentDateTime,
        forceStartDate ? this.currentDateTime : undefined
      );
    }
  }

  getNextTimeslot(): TimeSlot | null {
    if (!this.currentDateTime) {
      return null;
    }

    const nextTimeslot = this.timeSlotsOfDayIterator.getNextTimeSlot();

    if (nextTimeslot) {
      return nextTimeslot;
    }

    this.currentDateTime = this.daysIterator.getNextDateTime();

    if (this.currentDateTime) {
      this.timeSlotsOfDayIterator.setCurrentDateTime(this.currentDateTime);
      return this.timeSlotsOfDayIterator.getNextTimeSlot();
    } else {
      return null;
    }
  }
}
